import { ObservableStore } from '#glib/data/core/obvservable';

export interface IUiDomainData {
    showToS: boolean;
}

/**
 * UiDomain
 */
export class UiDomain extends ObservableStore<IUiDomainData> {

    /**
     * Class construcotr
     */
    public constructor() {
        super({
            showToS: false,
        });
    }
}